import { z } from 'zod';

export const generalFormErrorMessage = 'Dit veld is verplicht';

export const scoreExportValidation = z.object({
    quarter: z.coerce.string().min(1, {
        message: generalFormErrorMessage,
    }),
    year: z.coerce.string().min(1, {
        message: generalFormErrorMessage,
    }),
});
